import LayerSelector from "./LayerSelector";
import * as labels from "config.labels";
import * as _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as rateChangeSlice from "store/rateChange";
import * as pricingSelectors from "store/selectors/pricing/pricingSelectors";
import * as stateSelectors from "store/selectors/stateSelectors";

const PriorLayerSelector = ({
  loading,
  resolvedLayers,
  selectedId,
  onSelectId,
}) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");

  const title = translateLabel(labels.RATE_CHANGE_PRIOR_LAYER_SELECTOR_TITLE, {
    default: "Comparison Layer",
  });
  const subtitle = translateLabel(
    labels.RATE_CHANGE_PRIOR_LAYER_SELECTOR_SUBTITLE,
    {
      default: "Select a layer from the previous program.",
    }
  );

  return (
    <LayerSelector
      title={title}
      subtitle={subtitle}
      loading={loading}
      layers={resolvedLayers}
      selectedId={selectedId}
      onSelectId={onSelectId}
    />
  );
};

const mapStateToProps = (state) => {
  const priorState = stateSelectors.selectPriorState(state);
  return {
    loading: _.isEmpty(priorState),
    resolvedLayers: pricingSelectors.selectResolvedLayers(priorState),
    selectedId: rateChangeSlice.selectActiveLayerRateChange(state)
      ?.selectedPriorLayerId,
  };
};

const mapDispatchToProps = {
  onSelectId: rateChangeSlice.updateLayerPropertiesItem("selectedPriorLayerId"),
};
export default connect(mapStateToProps, mapDispatchToProps)(PriorLayerSelector);
